import { createContext, useContext } from 'react';

const AgentV4EnabledContext = createContext(false);

export const AgentV4EnabledProvider = AgentV4EnabledContext.Provider;

export function useAgentV4Enabled() {
  return useContext(AgentV4EnabledContext);
}
